module.exports = __webpack_public_path__ + "static/media/unfriend-icon.c9b9a3cf.png";